import Layout from "./components/Layout";
import Carousel from "./components/Carousel";
import HowItWorks from "./components/HowItWorks";
import OrderTracking from "./components/OrderTracking";
import ShippingPrices from "./components/ShippingPrices";
import Wholesale from "./components/WholeSale";
import OnlineStores from "./components/OnlineStores/HomeOnlineStores";
import ProhibitedRestrictedProducts from "./components/ProhibitedRestrictedProducts";
import UpdatesSection from "./components/UpdatesSection";
import FAQSection from "./components/FAQSection";
import PaymentMethods from "./components/PaymentMethods";

const HomePage = () => {
  return (
    <Layout>
      <Carousel />
      <HowItWorks />
      <OrderTracking />
      <ShippingPrices />
      <Wholesale />
      <OnlineStores />
      <ProhibitedRestrictedProducts />
      <UpdatesSection />
      <FAQSection />
      <PaymentMethods />
    </Layout>
  );
};

export default HomePage;
